 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLPREF00 from '@/components/xhtml/pref00'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLPREF01 from '@/components/xhtml/pref01'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLPREFACE from '@/components/xhtml/preface'
 import XHTMLFOREWORD from '@/components/xhtml/foreword'
 import XHTMLGETTING from '@/components/xhtml/getting'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLRESOURCES from '@/components/xhtml/resources'
 import XHTMLACKNOW from '@/components/xhtml/acknow'
 import XHTMLABOUT from '@/components/xhtml/about'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/preface",
 			"name" : "xhtml/preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/foreword",
 			"name" : "xhtml/foreword",
 			"component" : XHTMLFOREWORD
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js